import React, { useState } from "react";
 
const ReviewCards = ({ data }: { data: any }) => {
  console.log(data, ":::::::::::::ReviewCards");
 
  const [showAll, setShowAll] = useState(false); // State to control showing all reviews
 
  return (
    <div className="container mx-auto p-4 mt-10">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {data
          .slice(0, showAll ? data.length : 3)
          .map((review: any, index: number) => (
            <div key={index} className="bg-white p-6 flex flex-col">
              <div className="flex items-center mb-4">
                {review.customer_image ? (
                  <img
                    src={review.customer_image}
                    alt={review.customer_name}
                    className="w-12 h-12 rounded-full object-cover mr-4"
                  />
                ) : (
                  <div className="w-12 h-12 rounded-full bg-gray-500 text-white flex items-center justify-center mr-4">
                    <span className="text-xl font-bold">
                      {review.customer_name ? review.customer_name[0] : "N"}
                    </span>
                  </div>
                )}
                <div>
                  <h3 className="font-semibold">{review.customer_name}</h3>
                  <p className="text-sm text-gray-500">
                    {new Date(review.timestamp).toLocaleDateString("en-US", {
                      year: "numeric",
                      month: "long",
                      day: "numeric",
                    })}
                  </p>
                </div>
              </div>
              <p className="text-gray-700 flex-grow">
                {review.written_review || "No review"}
              </p>
            </div>
          ))}
      </div>
 
      {data.length > 3 && (
        <div className="flex text-center justify-center mt-6">
          <button
            className="text-pink-500 flex items-center font-semibold"
            onClick={() => setShowAll(!showAll)}
          >
            {showAll ? "Show Less Reviews" : "Show More Reviews"}{" "}
            <svg
              className="w-3 h-3 text-pink-500 dark:text-pink-500 ml-2"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 8 14"
            >
              <path
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d={
                  showAll
                    ? "m1 1 5.7 5.326a.909.909 0 0 0 0 1.348L1 13"
                    : "m1 13 5.7-5.326a.909.909 0 0 0 0-1.348L1 1"
                }
              />
            </svg>
          </button>
        </div>
      )}
    </div>
  );
};
 
export default ReviewCards;
 
 
 